import React from 'react';
import { Skeleton } from '../skeleton/Skeleton';
import { TimeslotSkeleton } from '../timeslot-list/TimeslotSkeleton';

export const TimeSelectorSkeleton = () => {
	return (
		<div>
			<Skeleton width='100%' height='62px' />
			<TimeslotSkeleton />
		</div>
	);
};
